var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-grow tw-items-center tw-justify-center"},[_c('img',{attrs:{"src":'/' + _vm.PLACEHOLDER_IMAGE_FILENAME,"alt":"No image available"}})])}
var staticRenderFns = []

export { render, staticRenderFns }